import React, { Fragment, useState } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import Icon from '../../../icon/Icon';
import {
  LoadingSpinner,
  LoadingSpinnerSizeModifiers,
} from '../../loading-spinner/LoadingSpinner';

import './PhotoThumbnail.scss';

export enum PhotoStatus {
  NEW = 'new',
  LOADING = 'loading',
  ERROR = 'error',
  SUCCESS = 'success',
}

const getContentByStatus = ({ status, src, error }) => {
  if (status === PhotoStatus.SUCCESS) {
    return <img src={src} />;
  }

  if (status === PhotoStatus.ERROR) {
    return <span className="photo-thumbnail_error">{error}</span>;
  }

  if ([PhotoStatus.LOADING, PhotoStatus.NEW].includes(status)) {
    return <LoadingSpinner size={LoadingSpinnerSizeModifiers.small} />;
  }

  return null;
};

export interface PhotoThumbnailProps {
  className?: string;
  onRemove?;
  src?;
  style?;
  status?;
  error?;
}

const PhotoThumbnail = ({
  className,
  onRemove,
  src,
  style,
  status,
  error,
}: PhotoThumbnailProps) => {
  const [showFullImage, setShowFullImage] = useState(false);
  return (
    <Fragment>
      {showFullImage && (
        <div className="image-preview">
          <img src={src} />
          <button onClick={() => setShowFullImage(false)}>
            <Icon name="cross-circle" />
          </button>
        </div>
      )}
      <div
        className={classnames('photo-thumbnail', status, className)}
        style={{ ...style, backgroundImage: `url(${src})` }}
        onClick={() => setShowFullImage(true)}
      >
        {getContentByStatus({ status, src, error })}
        {onRemove && (
          <button
            className="photo-thumbnail__remove"
            aria-label="Remove"
            type="button"
            onClick={() => onRemove()}
          >
            <Icon name="cross-circle" />
          </button>
        )}
        <button
          className="photo-thumbnail__zoom_in"
          aria-label="Zoom"
          type="button"
        >
          <Icon name="zoom-in" />
        </button>
      </div>
    </Fragment>
  );
};

PhotoThumbnail.propTypes = {
  status: PropTypes.string.isRequired,
  src: PropTypes.string.isRequired,
  error: PropTypes.string,
  onRemove: PropTypes.func,
};

export default PhotoThumbnail;
